<template>
    <!-- Способы оплаты-->
    <modal-window class="modal-payment" id="modal-payment" aria-label="Способы оплаты">
       <template v-slot:title>
            Способы оплаты
        </template>
        <template v-slot:body>
            <form id="form-payment" name="form-payment" method="post">
              <ul class="list list_unstyled payment-list">
                <li class="list__item radio">
                  <label class="radio__label" for="payment-avanse">
                    <input class="radio__hidden" type="radio" id="payment-avanse" name="payment" value="Авансовый" checked="checked"/><span class="radio__custom" aria-hidden="true"></span><span class="radio__title">Авансовый</span><span class="radio__text">Авансовый метод расчетов - это метод расчетов, при котором пользоваться услугами связи возможно только при положительном остатке на лицевом счете номера.</span>
                  </label>
                </li>
                <li class="list__item radio">
                  <label class="radio__label" for="payment-credit">
                    <input class="radio__hidden" type="radio" id="payment-credit" name="payment" value="Кредитный"/><span class="radio__custom" aria-hidden="true"></span><span class="radio__title">Кредитный</span><span class="radio__text">Кредитный метод расчётов - это метод расчетов за услуги, когда оплата осуществляется по окончании отчётного периода их предоставления (календарного месяца).</span>
                  </label>
                </li>
                <button class="btn btn_default btn_white btn_form js-send-payment" type="submit" aria-label="Подтвердить">ОК</button>
              </ul>
            </form>
        </template>
    </modal-window>
    <!-- Сообщение об успешной смене тарифного плана-->
    <modal-window class="modal_message" id="modal-success-plan" aria-label="Тарифный план изменен">
        <template v-slot:title>
            Тарифный план изменен
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Ваш текущий тарифный план успешно изменен на ТТС Box 2в1</p>
            </div><router-link class="btn btn_default btn_white btn_message" to="/">На главную</router-link>
        </template>
    </modal-window>
    <!-- Сообщение об успешной смене способа оплаты-->
    <modal-window class="modal_message" id="modal-success-payment" aria-label="Способ оплаты изменен">
        <template v-slot:title>
            Способ оплаты изменен
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Способ оплаты вашего тарифного плана успешно изменен на авансовый.</p>
            </div>
            <router-link class="btn btn_default btn_white btn_message" to="/" tupe="button" data-dismiss="modal">На главную</router-link>
        </template>
    </modal-window>
    <!-- Стандартное сообщение об ошибке-->
    <modal-window class="modal_message" id="modal-error" aria-label="Произошел сбой">
        <template v-slot:title>
            Произошел сбой
        </template>
        <template v-slot:body>
            <div class="section__description color-red">
              <p>Что-то произошло. Попробуйте повторить действие еще раз</p>
            </div>
            <button class="btn btn_default btn_white btn_message" tupe="button" data-dismiss="modal">Закрыть</button>
        </template>
    </modal-window>

    <!-- Смена телефона-->
    <!-- <modal-window class="modal_form" id="modal-edit-phone" aria-label="Изменить номер телефона">
        <template v-slot:title>
            Изменить номер телефона
        </template>
        <template v-slot:body>
            <form id="form-edit-phone" name="form-edit-phone" method="post">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-phone-new">Ваш номер телефона</label>
                <input class="form-control" type="tel" name="user-phone-new" id="user-phone-new" placeholder="+7 - - - - - - - - - -" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">Сохранить</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" data-dismiss="modal">Отмена</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window> -->
    <!-- Смена email-->
    <!-- <modal-window class="modal_form" id="modal-edit-email" aria-label="Изменить E-mail">
        <template v-slot:title>
            Изменить E-mail
        </template>
        <template v-slot:body>
            <form id="form-edit-email" name="form-edit-email" method="post">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-email-new">Ваш email</label>
                <input class="form-control" type="email" name="user-email-new" id="user-email-new" placeholder="useremail@gmail.com" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">Сохранить</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" data-dismiss="modal">Отмена</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window> -->
    <!-- Смена пароля-->
    <!-- <modal-window class="modal_form" id="modal-edit-password" aria-label="Изменить пароль">
        <template v-slot:title>
            Изменить пароль
        </template>
        <template v-slot:body>
            <form id="form-edit-password" name="form-edit-password" method="post">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-old">Старый пароль</label>
                <input class="form-control" type="password" name="user-password-old" id="user-password-old" placeholder="Старый пароль" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-new">Новый пароль</label>
                <input class="form-control" type="password" name="user-password-new" id="user-password-new" placeholder="Новый пароль" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">Сохранить</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" data-dismiss="modal">Отмена</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window> -->
    <!-- Настройка сообщений-->
    <!-- <modal-window class="modal_form" id="modal-edit-messages" aria-label="Настройка сообщений">
        <template v-slot:title>
            Настройка сообщений
        </template>
        <template v-slot:body>
            <form id="form-edit-messages" name="form-edit-messages" method="post">
              <ul class="list list_unstyled checkbox-list">
                <li class="list__item checkbox">
                  <label class="checkbox__label" for="messages-of-promotions">
                    <input class="checkbox__hidden" type="checkbox" id="messages-of-promotions" name="messages-of-promotions" value="Получать рассылку о новых акциях компании" checked="checked"/><span class="checkbox__custom svg-icon" aria-hidden="true">
                      <svg role="img" width="10" height="10">
                        <use xlink:href="#svg-icon-check"></use>
                      </svg></span><span class="checkbox__title">Получать рассылку о новых акциях компании</span>
                  </label>
                </li>
                <li class="list__item checkbox">
                  <label class="checkbox__label" for="messages-of-news">
                    <input class="checkbox__hidden" type="checkbox" id="messages-of-news" name="messages-of-news" value="Получать сообщения с новостями компании"/><span class="checkbox__custom" aria-hidden="true">
                      <svg role="img" width="10" height="10">
                        <use xlink:href="#svg-icon-check"></use>
                      </svg></span><span class="checkbox__title">Получать сообщения с новостями компании</span>
                  </label>
                </li>
              </ul>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">Сохранить</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" data-dismiss="modal">Отмена</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window> -->
    
    <!-- Тарифный план изменен-->
    <modal-window class="modal_message modal_edit-plan" id="modal-apply-plan" aria-label="Смена тарифного плана">
        <template v-slot:title>
            Тарифный план изменен
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Ваш текущий тарифный план успешно изменен на ТТС Box 2в1</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6"><router-link class="btn btn_default btn_white btn_message" to="/">На главную</router-link></div>
              </div>
            </div>
        </template>
    </modal-window>
    <!-- Связаться с оператором-->
    <modal-window class="modal_form" id="modal-request-call" aria-label="Смена тарифного плана">
        <template v-slot:title>
            Оставьте свои данные и мы обязательно вам перезвоним
        </template>
        <template v-slot:body>
            <form id="form-request-call" name="form-request-call" method="post">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-name">Ваше имя</label>
                <input class="form-control" type="text" name="user-name" id="user-name" placeholder="ФИО" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-phone">Ваш номер телефона</label>
                <input class="form-control" type="tel" name="user-phone" id="user-phone" placeholder="+7 - - - - - - - - - -" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-subject">Характер вопроса</label>
                <!-- если ошибка при отправлении формы-->
                <input class="form-control form-control_error" type="text" name="user-subject" id="user-subject" placeholder="Характер вопроса" required="required"/>
                <div class="form-validator">Заполните это поле</div>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_white js-request-call" type="submit">Заказать звонок</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window>
    <!-- Тарифный план изменен-->
    <modal-window class="modal_message" id="modal-success-request" aria-label="Спасибо за заявку">
        <template v-slot:title>
            Спасибо за заявку
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Мы свяжемся с вами вближайшее время!</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6"><router-link class="btn btn_default btn_white btn_message" to="/">На главную</router-link></div>
              </div>
            </div>
        </template>
    </modal-window>
    <!-- Забронировано-->
    <modal-window class="modal_message" id="modal-success-reservation" aria-label="Забронировано">
        <template v-slot:title>
            Забронировано
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Услуга “бронирование" для интернета успешно добавлена на период с 27.11.2019 до 20.02.2020</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6"><router-link class="btn btn_default btn_white btn_message" to="/">На главную</router-link></div>
              </div>
            </div>
        </template>
    </modal-window>
    <!-- Оплата онлайн
    <modal-window class="modal_form modal_pay-online" id="modal-pay-online" aria-label="Оплата онлайн">
        <template v-slot:title>
            Оплата онлайн
        </template>
        <template v-slot:body>
            <form id="form-pay-online" name="form-pay-online" method="post">
              <div class="form-group">
                <label class="form-label" for="pay-online-sum">Платеж, тг</label>
                <input class="form-control" type="number" name="pay-online-sum" id="pay-online-sum" placeholder="0.00" min="0" required="required"/>
                <div class="form-validator">Сумма не может быть меньше 0 тг</div>
              </div>
              <div class="form-descr color-gray section__description">Комиссия банка: 20.00 тг.</div>
              <div class="form-sum color-green">Итого: 120.00 тг.</div>
              <div class="checkbox">
                <label class="checkbox__label" for="user-agreement">
                  <input class="checkbox__hidden" type="checkbox" id="user-agreement" name="user-agreement" value="согласие с договором публичной оферты"/><span class="checkbox__custom" aria-hidden="true">
                    <svg role="img" width="10" height="10">
                      <use xlink:href="#svg-icon-check"></use>
                    </svg></span><span class="checkbox__title">Оплачивая, вы подтверждаете согласие с договором публичной оферты, расположенным по адресу <a href="https://ttc.kz/files/ru/documents/public_new.pdf" target="_blank">https://ttc.kz/files/ru/documents/public_new.pdf</a></span>
                </label>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green js-go-to-pay" type="submit">Перейти к оплате</button>
                  </div>
                </div>
              </div>
            </form>
        </template>
    </modal-window> -->
    <!-- Удалить сообщение-->
    <!-- <modal-window class="modal_remove-message" id="modal-remove-message" aria-label="Удалить сообщение">
        <template v-slot:title>
            Удалить сообщение
        </template>
        <template v-slot:body>
            <div class="section__description color-green">
              <p>Удалить сообщение "Ваш тарифный план успешно изменен"?</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6">
                  <button class="btn btn_default btn_green js-remove-message" type="button">Да</button>
                </div>
                <div class="col-12 col-md-6 order-last order-md-first">
                  <button class="btn btn_default btn_white" type="button" data-dismiss="modal">Нет</button>
                </div>
              </div>
            </div>
        </template>
    </modal-window> -->
    <!-- Список каналов-->
    <modal-window class="modal-channels" id="modal-channels" aria-label="Список каналов">
        <template v-slot:title>
            Список каналов
        </template>
        <template v-slot:body>
            <div class="table-responsive">
              <table class="table table_default">
                <thead class="thead">
                  <tr class="tr">
                    <th class="th">№</th>
                    <th class="th">Канал</th>
                    <th class="th">Категория</th>
                  </tr>
                </thead>
                <tbody class="tbody">
                  <tr class="tr">
                    <td class="td">1</td>
                    <td class="td">Qazaqstan HD</td>
                    <td class="td">Общие</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">2</td>
                    <td class="td">Qazaqstan</td>
                    <td class="td">Развлекательные</td>
                  </tr>
                  <tr class="tr">
                    <td class="td">3</td>
                    <td class="td">Хабар HD</td>
                    <td class="td">Общие</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </template>
    </modal-window>
</template>
<script>
import ModalWindow from "@/components/UI/ModalWindow";
export default {
  components: {
    ModalWindow
  }
}
</script>
<style>

</style>